import { getResolvedRef } from "../../helpers/get-resolved-ref.js";
import { getTag } from "../../navigation/helpers/get-tag.js";
const createSchemaEntry = (ref, name = "Unknown", titlesMap, getModelId, tag, _schema) => {
  const id = getModelId({ name }, tag);
  const schema = getResolvedRef(_schema);
  const title = schema && "title" in schema && schema.title || name;
  titlesMap.set(id, title);
  return {
    id,
    title,
    name,
    ref,
    type: "model"
  };
};
const traverseSchemas = (content, tagsMap, titlesMap, getModelId) => {
  const schemas = content.components?.schemas ?? {};
  const untagged = [];
  for (const name in schemas) {
    const schema = getResolvedRef(schemas[name]);
    if (schema?.["x-internal"] || schema?.["x-scalar-ignore"] || !Object.hasOwn(schemas, name)) {
      continue;
    }
    const ref = `#/content/components/schemas/${name}`;
    if (schema?.["x-tags"]) {
      schema["x-tags"].forEach((tagName) => {
        const { tag } = getTag(tagsMap, tagName);
        tagsMap.get(tagName)?.entries.push(createSchemaEntry(ref, name, titlesMap, getModelId, tag));
      });
    } else {
      untagged.push(createSchemaEntry(ref, name, titlesMap, getModelId, void 0, getResolvedRef(schemas[name])));
    }
  }
  return untagged;
};
export {
  traverseSchemas
};
//# sourceMappingURL=traverse-schemas.js.map
